import React from "react";
import { OrderCreationPriceCalculator } from "../../../helpers/digitalized-orders/orderCreationPriceCalculator";
import { FSMoneyFactory } from "../../../helpers/money/moneyFactory";
import { MoneyFormatter } from "../../../helpers/money/moneyFormatter";

export const OrderUnit = ({ orderUnit, count, isFree }) => (
  <div className="order-unit-box">
    <p>
      <strong>Name: </strong>
      {orderUnit?.name}
    </p>
    <p>
      <strong>Anzahl: </strong>
      {count}
    </p>
    <p>
      <strong>Produkte:</strong>
    </p>
    {orderUnit?.orderUnitsProducts?.map((oup, oupIndex) => {
      const product = orderUnit.products.find(x => x.id === `${oup.productId}`);

      return (
        <div className="order-unit-product" key={oupIndex}>
          {product?.images.length > 0 && (
            <div className="order-unit-product-image-container">
              <img src={product?.images[0]?.thumbnail} alt="Produkt" />
            </div>
          )}
          <div className="product-details">
            <p>
              <strong>Produkt: </strong>
              {product?.productVariantName}
            </p>
            <p>
              <strong>Verkaufseinheiten in der Bestelleinheit: </strong>
              {oup.productCount}
            </p>
          </div>
        </div>
      );
    })}
    <p>
      <strong>Netto Bestellwert: </strong>
      {isFree
        ? MoneyFormatter.fromBigCents(FSMoneyFactory.toMoney(0))
        : MoneyFormatter.fromBigCents(
            OrderCreationPriceCalculator.getOrderUnitPrice(orderUnit).times(
              count,
            ),
          )}
    </p>

    <p>
      <strong>Pfand: </strong>
      {MoneyFormatter.fromBigCents(
        FSMoneyFactory.toMoney(orderUnit?.shippingUnitDepositValueCents).times(
          count,
        ),
      )}
    </p>
  </div>
);
